import React, { useEffect, useRef, useState } from "react";
import './VerIncidencias.scss';
import TitleView from "../../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { CustomerService } from './service/CustomerService';
import { actualizarValidacionVisualizacion, addTaxi, chatGPTApiPost, delTaxi, getIncidencias, getTaxi, updateTaxi } from "./VerIncidenciasIntegracion";
import { convertirFormatoFecha, formateoBasico, isoAUtc } from "../../../utilities/formateos";
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import Button from "../../../components/atoms/Button/Button";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputTextMy from "../../../components/atoms/InputText/InputText";
import ButtonGris from "../../../components/atoms/ButtonGris/ButtonGris";
import BotonDescargarExel from "../../../components/atoms/BotonDescargarExel/BotonDescargarExel";
import useGetScreenSize from "../../../CustomHooks/useGetScreenSize";
import chatGPT from '../../../assets/icons/chatgpt.png'
import taxiIcon from '../../../assets/icons/taxi.png'
import palomitaIcon from '../../../assets/icons/palomita.png'
import xIcon from '../../../assets/icons/x.png'
import saveIcon from '../../../assets/icons/save.png'
import InputLista from "../../../components/atoms/InputLista/InputLista";
import { Tooltip } from "@mui/material";
import useGetDataUser from "../../../CustomHooks/useGetDataUser.jsx";
import { InputNumber } from "primereact/inputnumber";
import TextArea from "../../../components/atoms/TextArea/TextArea.jsx";
import Swal from "sweetalert2";
import { InputSwitch } from "primereact/inputswitch";
import ScrollToTopButton from "../../../components/atoms/ScrollToTopButton.jsx";

const VerIncidencias = () => {
    const toast = useRef(null);
    const [data, setData] = useState(null);
    const dt = useRef(null)
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [visible, setVisible] = useState(false);
    const [visibleIA, setvisibleIA] = useState(false);
    const [dataModal, setDataModal] = useState([]);
    const [fechaInicio, setFechaInicio] = useState(formateoBasico(new Date()));
    const [fechaFin, setFechaFin] = useState(formateoBasico(new Date()));
    const [exesoVel, setExesoVel] = useState(false);
    const [cancelServicio, setCancelServicio] = useState(false);
    const [no_requiere_serv, setNo_requiere_serv] = useState(false);
    const [numeroDeColumnas, setNumeroDeColumnas] = useState(0);
    const [cliente, setCliente] = useState(null);
    const [filters, setFilters] = useState({
        // global: { value: null, matchMode: FilterMatchMode.EQUALS },
        NOMBRE_FILTER: { value: null, matchMode: FilterMatchMode.IN },
        PROVEEDOR: { value: null, matchMode: FilterMatchMode.EQUALS },

    });
    const [MostrarData, setMostrarData] = useState(null)
    const [detalleChatGPT, setDetalleChatGPT] = useState("")
    const [respuestaGPT, setrespuestaGPT] = useState("")
    const screenSize = useGetScreenSize()
    const dataUser = useGetDataUser()
    const [loading, setLoading] = useState(true);

    // taxis
    const [modaTaxiDefault, setModaTaxiDefault] = useState()
    const [monto, setMonto] = useState()
    const [motivo, setMotivo] = useState()
    const [correosNotificar, setCorreosNotificar] = useState()
    const [items, setItems] = useState([]);

    const [editedRows, setEditedRows] = useState();
    const inputRef = useRef(null);
    const inputRefMonto = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [descuentoAutomatico, setDescuentoAutomatico] = useState(false);
    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };
    const textEditor = (options) => {


        return (
            <InputText
                ref={inputRef}
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}
                onMouseLeave={() => {
                  

                    if (inputRef.current) inputRef.current.blur(); // fuerza el blur
                    document.getElementById("registrarTaxis").click()
                }}
            />
        )
    };

    const numberEditor = (options) => {
        return (
            <div style={{ display: "flex" }} >
                <span className="p-inputgroup-addon">
                    <i className="pi pi-dollar" />
                </span>
                <InputNumber
                    ref={inputRefMonto}
                    className="inputNumber"
                    mode="currency"
                    currency="MXN"
                    locale="es-MX"
                    placeholder="Monto"
                    value={options.value}
                    onValueChange={(e) => options.editorCallback(e.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    onMouseLeave={() => {
                        console.log(inputRefMonto.current.getInput());

                        if (inputRefMonto.current) {
                            const inputElement = inputRefMonto.current.getInput(); // Obtener el input real
                            if (inputElement) {
                                inputElement.blur(); // Llamar blur en el input real
                            }
                        }

                        // Simula el clic en el botón "registrarTaxis"
                        document.getElementById("registrarTaxis").click();
                    }}
                />
            </div>
        )
    }




    const indicadorTemplate = (rowData, fieldName) => {
        const isPositive = rowData[fieldName];
        return (
            <div className="indicador-container">
                <div className="indicador">
                    {/* <div className="title">{fieldName.toUpperCase()}</div> */}
                    <div className={isPositive ? 'forma' : 'forma-negativa'}>
                        <img src={isPositive ? palomitaIcon : xIcon} alt={isPositive ? 'Positivo' : 'Negativo'} />
                    </div>
                </div>
            </div>
        );
    };

    const actionTemplate = (rowData) => {

      
        
        const params = {
            id_incidencia:rowData.ID_INCIDENTE,
            id_reembolso: rowData.id,
            monto: rowData.monto,
            motivo: rowData.motivo,
            id_usuario: dataUser.ID
        }
      

        return (
            <div style={{ display: "flex", gap: '5px', justifyContent: "center" }}>
                <ButtonGris onClick={() => { updateTaxi(params) }} className="boton-actions-edit" icon="pi pi-check" label="Guardar" ><img className="icon" src={saveIcon} alt="" /></ButtonGris>
                <ButtonGris icon="pi pi-times" label="Cancelar" className="boton-actions-edit" ><img className="icon" src={xIcon} alt="" onClick={async () => { await eliminarTaxi(rowData) }} /></ButtonGris>
            </div>
        );
    };
    const eliminarTaxi = async (rowData) => {
        await delTaxi(rowData.id)
        await getTaxi(rowData.ID_INCIDENTE, setItems)
    

    }
    const onCellEditComplete = (e) => {
        const { rowData, newValue, field, originalEvent: event } = e;

        let updatedValue = newValue;
        if (field === 'monto') {
            if (typeof newValue !== 'number' || newValue < 0) {
                event.preventDefault();
                return;
            }
        } else if (typeof newValue !== 'string' || newValue.trim().length === 0) {
            event.preventDefault();
            return;
        }

        const updatedItem = { ...rowData, [field]: updatedValue };



        setItems((prevItems) =>
            prevItems.map((item) => (item.id === rowData.id ? updatedItem : item))
        );

        setEditedRows((prevEdited) => ({
            ...prevEdited,
            [rowData.id]: updatedItem,
        }));
    };
    useEffect(() => {
        const funct = async () => {
            await getIncidencias(setData, setLoading, fechaInicio, fechaFin, exesoVel, cancelServicio, no_requiere_serv, setDetalleChatGPT, cliente)
        }
        funct()
    }, []);

    useEffect(() => {
        if (modaTaxiDefault == false) {
            setModaTaxiDefault()
            setMonto()
            setMotivo()
            setCorreosNotificar()
            setItems([])
        }
    }, [modaTaxiDefault]);
    useEffect(() => {
    }, [data]);
    useEffect(() => {
        if (MostrarData) {
            actualizarCampoMostrar()
        }
    }, [MostrarData])
    const getSeverity = (status) => {
        if (status == 'SUMA TE LLEVA') {
            return 'danger';
        }
        else {
            return 'info'
        }
    };
    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText type="search"
                        placeholder="Buscar..."
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange} />
                </IconField>
            </div>
        );
    };
    const representativeBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <td data-label="NOMBRE">{rowData?.NOMBRE}</td>
            </div>
        );
    };
    const representativesItemTemplate = (option) => {
        
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };
    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.PROVEEDOR} severity={getSeverity(rowData.PROVEEDOR)} />;
    };
    const statusItemTemplate = (option) => {
        return <Tag value={option} severity={getSeverity(option)} />;
    };
    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown optionLabel="name" value={options.value} options={data?.selectProveedor} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Proveedor" className="p-column-filter negreitas filtro" showClear style={{ minWidth: '12rem' }} />
        );
    };
    const representativeRowFilterTemplate = (options) => {
        
        return (
            
            <MultiSelect

                value={options.value}
                options={data?.selectNombre}
                itemTemplate={representativesItemTemplate}
                onChange={(e) => {
                    
                    options?.filterApplyCallback(e.value);
                }}
                optionLabel="name"
                placeholder="Usuario"
                className="p-column-filter filtro"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };
    const formatoFecha = (rowData) => {
        return (
            <td data-label="FECHA">{convertirFormatoFecha(isoAUtc(rowData.FECHA))}</td>
        )
    }
    const onRowSelect = (event) => {
        setVisible(true)
        setDataModal(event.data)

    };
    const onRowUnselect = (event) => {
        setVisible(true)
        setDataModal(event.data)
        // toast?.current?.show({ severity: 'warn', summary: 'Product Unselected', detail: `Name: ${event.data.name}`, life: 3000 });
    };
    const verificar = (rowData) => {
        const value = JSON.parse(rowData.MOSTRAR_JSON)
        return (
            <div className="Verificar">
                <InputLista onClick={(e) => e.stopPropagation()} value={value ? value : null} onChange={(e) => { setMostrarData({ opcion: e.value, id: rowData.ID }) }} obligatory={false} options={[{ name: 'Sí', code: 1 }, { name: 'No', code: 0 }]}></InputLista>
            </div>
        )
    };
    const actualizarCampoMostrar = async () => {
        const params = {
            usuario_verifico: dataUser.ID,
            mostrar: MostrarData.opcion.code,
            id_incidencia: MostrarData.id
        }
        await actualizarValidacionVisualizacion(params)
        await getIncidencias(setData, setLoading, fechaInicio, fechaFin, exesoVel, cancelServicio, no_requiere_serv, setDetalleChatGPT, cliente)

    }
    const filtrar = async () => {
        setLoading(false)
        setData([])
        await getIncidencias(setData, setLoading, fechaInicio, fechaFin, exesoVel, cancelServicio, no_requiere_serv, setDetalleChatGPT, cliente)

    }
    const header = renderHeader();
    useEffect(() => {
        if (screenSize.heigth > 900) {

            setNumeroDeColumnas(20)
        }
        else {
            setNumeroDeColumnas(10)
        }
    }, [screenSize])
    const chatGPTApi = () => {
        if (detalleChatGPT) {
            chatGPTApiPost(detalleChatGPT, setrespuestaGPT, setvisibleIA)
        }
    }
    const taxis = async (rowData) => {

        setModaTaxiDefault(rowData)
        await getTaxi(rowData.ID, setItems)

    }
    const taxisTemplate = (rowData) => {

        return (
            <div className="taxiButtonContainer">
                {rowData.ID_EFECTO == 1 || rowData.ID_EFECTO == 2 ?
                    <div>
                        <button
                            width={"50px"}
                            onClick={() => { taxis(rowData) }}
                            // onClick={() => contratarTaxi(rowData)}
                            className="buttonTaxi"
                        >
                            <img src={taxiIcon} width={30} alt="" />
                        </button>
                    </div>
                    :
                    <Tooltip title="No requiere taxi">
                        <div className="noTxi">

                        </div>
                    </Tooltip>
                }
            </div>
        )
    }
    const headerTaxiTemplate = () => {
        return (
            <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                <Button onClick={() => { window.open(`/monitoreo/solicitud-reembolso/${modaTaxiDefault.ID}`, '_blank') }} width="">Ver Solicitud de servicio</Button>
            </div>
        )
    }
    const submitTaxis = async () => {

      
        
        if (monto && motivo && correosNotificar) {
            const params = {
                id_usuario: dataUser.ID,
                nombre_usuario: dataUser.NOMBRE,
                email_usuario: dataUser.EMAIL,
                id_ruta: modaTaxiDefault.ID_RUTA,
                monto: monto,
                motivo: motivo,
                correos_notificar: correosNotificar,
                id_cliente: modaTaxiDefault.ID_CLIENTE,
                id_chofer: modaTaxiDefault.ID_OPERADOR,
                id_proveedor: modaTaxiDefault.ID_PROVEEDOR,
                id_incidente: modaTaxiDefault.ID,
                descuento_automatico:descuentoAutomatico,
                id_unidad:modaTaxiDefault.ID_UNIDAD
            }
            const addTaxis = async () => {
                await addTaxi(params)
            }
            const getTaxis = async () => {
                await getTaxi(params.id_incidente, setItems)
            }
            await addTaxis()
            await getTaxis()

        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                title: 'Oops...', // Título de la alerta
                text: 'Rellena todos los campos', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }
    }
    const montoBodyTemplate = (rowData) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        }).format(rowData.monto);
    };

    return (
        <div className="VerIncidencias">
            <ScrollToTopButton/>
            <TitleView title={"Ver Incidencias"} />
            <GlovalCard>
                <div className="flitros">
                    <InputCalendario value={fechaInicio} onChange={(e) => { setFechaInicio(e.target.value) }} titulo={"Fecha inicio"} obligatorio={false} className={"calendario"}></InputCalendario>
                    <InputCalendario value={fechaFin} onChange={(e) => { setFechaFin(e.target.value) }} titulo={"Fecha fin"} obligatorio={false} className={"calendario"}></InputCalendario>
                    <InputLista className={"calendario"} titulo={"Cliente"} value={cliente} onChange={(e) => { setCliente(e.value) }} options={data?.selectCliente}></InputLista>
                    <InputTextMy className={"check"} value={exesoVel} checked={exesoVel} onChange={(e) => { setExesoVel(e.target.checked) }} type="checkbox" title="Excesos de velocidad"></InputTextMy>
                    <InputTextMy className={"check"} value={cancelServicio} checked={cancelServicio} onChange={(e) => { setCancelServicio(e.target.checked) }} type="checkbox" title="Se cancela el servicio"></InputTextMy>
                    <InputTextMy className={"check"} value={no_requiere_serv} checked={no_requiere_serv} onChange={(e) => { setNo_requiere_serv(e.target.checked) }} type="checkbox" title="No requiere Servicio"></InputTextMy>

                    <ButtonGris width="fit-content" onClick={filtrar}>Filtrar</ButtonGris>
                    <BotonDescargarExel datos={{ header: data?.headers, data: data?.data }} nombreArchivo={"incidentes"} dt={dt}></BotonDescargarExel>
                    <img src={chatGPT} width={40} style={{ cursor: "pointer" }} onClick={() => { chatGPTApi() }}></img>
                </div>
                <div className="card">
                    <DataTable
                        ref={dt}

                        value={data?.data} // Usa filteredData si existe
                        paginator
                        rows={numeroDeColumnas}
                        first={0}

                        dataKey="ID"

                        filterDisplay="row"
                        loading={loading}
                        header={header}
                        emptyMessage="No se encontraron resultados."
                        globalFilter={globalFilterValue}
                        globalFilterFields={[
                            'ID',
                            'FECHA',
                            'CAUSA',
                            'RUTA',
                            'CLIENTE',
                            'TURNO',
                            'PROVEEDOR',
                            'OPERADOR',
                            'ID_BITACORA',
                            'RESPONSABILIDAD_SUMA',
                            'AFECTO_SERVICIO',
                            'NOMBRE'
                        ]}
                        selectionMode="single"
                        selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)}
                        onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} metaKeySelection={false}
                    >
                        <Column
                            header="ID"
                            field="ID"
                            body={(rowData) => <td data-label="ID">{rowData.ID}</td>}
                        />
                        <Column
                            header="Fecha"
                            field="FECHA"
                            body={formatoFecha}
                        />
                        <Column
                            header="Causa"
                            field="CAUSA"
                            body={(rowData) => <td style={{ maxWidth: "300px" }} data-label="CAUSA">{rowData.CAUSA}</td>}
                        />
                        <Column
                            header="Ruta"
                            field="RUTA"
                            body={(rowData) => <td data-label="RUTA">{rowData.RUTA}</td>}
                        />
                        <Column
                            header="Cliente"
                            field="CLIENTE"
                            body={(rowData) => <td data-label="CLIENTE">{rowData.CLIENTE}</td>}
                        />
                        <Column
                            header="Turno"
                            field="TURNO"
                            body={(rowData) => <td data-label="TURNO">{rowData.TURNO ? rowData.TURNO : "No asignado"}</td>}
                        />
                        <Column
                            field="PROVEEDOR"
                            header={'PROVEEDOR'}
                            showFilterMenu={false}
                            filterMenuStyle={{ width: '14rem' }}
                            style={{ minWidth: '12rem' }}
                            body={statusBodyTemplate}
                            filter
                            filterElement={statusRowFilterTemplate}

                        />
                        <Column
                            header="Operador"
                            field="OPERADOR"
                            body={(rowData) => <td data-label="OPERADOR">{rowData.OPERADOR}</td>}
                        />
                        <Column
                            header="Bitacora"
                            field="ID_BITACORA"
                            body={(rowData) => <td data-label="ID_BITACORA">{rowData.ID_BITACORA}</td>}
                        />
                        <Column
                            header="Responsabilidad suma"
                            field="RESPONSABILIDAD_SUMA"
                            body={(rowData) => <td data-label="RESPONSABILIDAD_SUMA">{rowData.RESPONSABILIDAD_SUMA ? "SI" : 'NO'}</td>}
                        />
                        <Column
                            header="afecto"
                            field="AFECTO_SERVICIO"
                            body={(rowData) => <td data-label="AFECTO_SERVICIO">{rowData.AFECTO_SERVICIO ? "SI" : 'NO'}</td>}
                        />
                        <Column
                            // header={() => { return (<><div className="headerPosition"></div></>) }}
                            header={'Realizada por'}
                            field="NOMBRE"
                            filterField="NOMBRE_FILTER"
                            showFilterMenu={false}
                            filterMenuStyle={{ width: '14rem' }}
                            style={{ minWidth: '14rem' }}
                            body={representativeBodyTemplate}
                            filter
                            filterElement={representativeRowFilterTemplate}
                            filterMatchMode="in" // ✅ ESTA LÍNEA ES CLAVE
                        />
                        <Column
                            header="Mostrar"
                            field="USUARIO_VERIFICO"
                            body={verificar}

                        />
                        <Column
                            header="Taxis"
                            field="TAXIS"
                            body={taxisTemplate}

                        />

                        {/* <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} body={statusBodyTemplate} filter filterElement={statusRowFilterTemplate} /> */}
                    </DataTable>
                </div>
            </GlovalCard>
            <Dialog header={() => { return (<>ASUNTO : {dataModal?.ASUNTO ? dataModal?.ASUNTO : "Sin asunto"}</>) }} visible={visible} style={{ width: '50vw' }} onClick={(e) => { e.stopPropagation(); }} onHide={() => { if (!visible) return null; setVisible(false); setDataModal(null) }} >
                <div className="contenerdorModal">
                    <div className="col1">

                        <div className="contenidoModal"><div className="titlem">ID :</div> <div>{dataModal?.ID ? dataModal?.ID : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">ID de bitacora :</div><div>{dataModal?.ID_BITACORA ? dataModal.ID_BITACORA : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Fecha de captura :</div> <div>{dataModal?.FECHA_CAPTURA ? convertirFormatoFecha(isoAUtc(dataModal.FECHA_CAPTURA)) : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Fecha :</div><div>{dataModal?.FECHA ? convertirFormatoFecha(isoAUtc(dataModal.FECHA)) : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Operador :</div><div>{dataModal?.OPERADOR ? dataModal.OPERADOR : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Proveedor :</div><div>{dataModal?.PROVEEDOR ? dataModal.PROVEEDOR : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Ruta :</div><div>{dataModal?.RUTA ? dataModal.RUTA : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Turno:</div><div>{dataModal?.TURNO ? dataModal.TURNO : "sin dato"}</div></div>
                    </div>

                    <div className="col2">
                        <div className="contenidoModal"><div className="titlem">Afecto el servicio :</div><div>{dataModal?.AFECTO_SERVICIO ? '   Si' : "No"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Cliente :</div><div>{dataModal?.CLIENTE ? dataModal.CLIENTE : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Causa :</div><div>{dataModal?.CAUSA ? dataModal.CAUSA : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Detalle :</div><div>{dataModal?.DETALLE ? dataModal.DETALLE : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Efecto :</div><div>{dataModal?.EFECTO ? dataModal.EFECTO : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Registrado por :</div><div>{dataModal?.NOMBRE ? dataModal.NOMBRE : "sin dato"}</div></div>
                        <div className="contenidoModal"><div className="titlem">Responsabilidad suma :</div><div>{dataModal?.RESPONSABILIDAD_SUMA ? 'Si' : "No"}</div></div>

                    </div>
                    <div className="container">
                        {/* <Button width="" onClick={(e)=>{e.stopPropagation();setVisible(false);setDataModal(null)}}>Cerrar</Button> */}
                    </div>

                </div>

            </Dialog>
            <Dialog header={() => { return (<>IA - RESPUESTA</>) }} visible={visibleIA} style={{ width: '50vw' }} onHide={() => { if (!visibleIA) return; setvisibleIA(false); }} >
                <div>
                    <p dangerouslySetInnerHTML={{ __html: respuestaGPT }}></p>
                </div>

            </Dialog>
            <Dialog header={() => { return (<>REGISTRAR TAXIS</>) }} visible={modaTaxiDefault} className="tamañoModal" onHide={() => { if (!modaTaxiDefault) return; setModaTaxiDefault(false); }} >
                <div className="registrarTaxis" id='registrarTaxis'>
                    <div className="container-price">

                        <div className="conatinerInputPrice">
                            <div className="negritas" style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "0.8rem" }}>Monto</div>
                            <div className="inputPrice">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-dollar" />
                                </span>
                                <InputNumber
                                    className="inputNumber"
                                    value={monto}
                                    onValueChange={(e) => { setMonto(e.value) }}
                                    mode="currency"
                                    currency="MXN"
                                    locale="es-MX"
                                    placeholder="Monto"
                                />
                            </div>
                        </div>
                        <div className="container-text">
                            <div className="baseText negritas">Incidencia : {modaTaxiDefault?.ID} - {modaTaxiDefault?.EFECTO}</div>
                            {/* <div className="baseText"></div> */}
                        </div>
                    </div>
                    <div className="textAreaContainer">
                        <div className="col">
                            <TextArea titulo="Motivo" value={motivo} onChange={(e) => { setMotivo(e.target.value) }}></TextArea>
                        </div>
                        <div className="col">
                            <TextArea titulo="Correos a notificar" value={correosNotificar} onChange={(e) => { setCorreosNotificar(e.target.value) }}></TextArea>
                        </div>
                    </div>
                    <div className="footer">
                            <div className="desc-auto">
                                <div className="desc-titulo">Generar Descuento automaticamente</div>
                                <InputSwitch checked={descuentoAutomatico} onChange={(e) => setDescuentoAutomatico(e.value)} />
                            </div>
                        <div>
                            <Button width="180px" className={"mt"} onClick={() => { submitTaxis() }} >Registrar</Button>
                        </div>
                    </div>
                    {/* ------------------------------------------------------------- taxis agregados */}
                    <DataTable
                        value={items}
                        editMode="cell"
                        dataKey="id"
                        tableStyle={{ minWidth: '80rem' }}
                        emptyMessage="No se encontraron resultados."
                        header={headerTaxiTemplate}
                    >
                        <Column field="id" header="ID" />
                        <Column field="fecha" header="Fecha" />
                        <Column
                            field="motivo"
                            header="Motivo"
                            editor={textEditor}
                            onCellEditComplete={onCellEditComplete}

                        />
                        <Column
                            field="monto"
                            header="Monto"
                            editor={numberEditor}
                            onCellEditComplete={onCellEditComplete}
                            body={montoBodyTemplate}
                        />
                        <Column field="operador" header="Operador" />
                        <Column
                            header="PAGADO"
                            body={(rowData) => indicadorTemplate(rowData, 'pagado')}

                        />
                        <Column
                            header="CONCILIADO"
                            body={(rowData) => indicadorTemplate(rowData, 'conciliado')}

                        />
                        <Column
                            header="Acciones"
                            body={actionTemplate}
                        />
                    </DataTable>

                </div>

            </Dialog>
        </div>
    );
};

export default VerIncidencias;